'use strict';
var allPopulationSpans = document.querySelectorAll('.population');
var totalPopulation = 0;
var validCount = 0;
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = allPopulationSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var spanEl = _step.value;
        var parsedValue = spanEl.textContent;
        var currentNumber = Number(parsedValue.split(',').join(''));
        if (Number.isNaN(currentNumber)) continue;
        totalPopulation += currentNumber;
        validCount++;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var average = validCount > 0 ? totalPopulation / validCount : 0;
var formatter = new Intl.NumberFormat('en-US');
var formattedAverage = formatter.format(average);
var formattedTotal = formatter.format(totalPopulation);
var averageNode = document.querySelector('.average-population');
var totalNode = document.querySelector('.total-population');
averageNode.textContent = formattedAverage;
totalNode.textContent = formattedTotal;

//# sourceMappingURL=js_get_data_DOM.59bb8c1e.js.map
